import { Injectable } from '@angular/core';

import { RequestConfig } from '../../../shared/rest/rest.request';
import { RequestMethod, RequestOptions } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { CustomHttp } from '../../../common/http/custom.http';
import {environment} from "../../../../environments/environment";

import Any = jasmine.Any;
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { EngineeringRegistration } from 'app/+task/details/task-details.component';
@Injectable({
  providedIn: 'root'
})
export class VentasService {
  private STREET_REQUEST = new RequestConfig('FOLIO06', 'application/json', true, RequestMethod.Get, '/calles');
  private GET_COLONIAS = new RequestConfig('SLS015', 'application/json', true, RequestMethod.Get, '/colonia');
  private GET_COLONIAS_DOM = new RequestConfig('SLS015', 'application/json', true, RequestMethod.Get, '/colonias');
  private GET_DOMICILIOS = new RequestConfig('SLS013', 'application/json', true, RequestMethod.Post, '/ventas/busquedaDomicilios');
  private POST_TICKET: RequestConfig = new RequestConfig('TC003', 'application/json', true, RequestMethod.Post, '/tickets', true);
  private POST_PORTABILIDAD: RequestConfig = new RequestConfig('TC003', 'application/json', true, RequestMethod.Post, '/consultarPortabilidad', true);
  private GET_PACKAGES: RequestConfig = new RequestConfig('SL007', 'application/json', true, RequestMethod.Post, '/ventas/packages', true);
  private GET_SALES_FOLIOS: RequestConfig = new RequestConfig('SL008', 'application/json', true, RequestMethod.Get, '/foliosCuadrilla', true); 
 private GET_SALES_FOLIOS_DIGITAL: RequestConfig = new RequestConfig('SL008', 'application/json', true, RequestMethod.Get, '/folioDigitalOffline', true);
  private CREATE_SALE: RequestConfig = new RequestConfig('SL003', 'application/json', true, RequestMethod.Post, '/ventas/crearVenta', true);
  private FOLIO: RequestConfig = new RequestConfig('SL004', 'application/json', true, RequestMethod.Post, '/folioElectronico', true);
  private POST_RECOVERY: RequestConfig = new RequestConfig('RECO001', 'application/json', true, RequestMethod.Post, '/tickets/task/recuperacion', false);
  private CUSTOMER_SERVICES: RequestConfig = new RequestConfig('SLS002', 'application/json', true, RequestMethod.Get, '/ventas/serviciosCliente', true);
  private GET_PROMOCION: RequestConfig = new RequestConfig('SL003', 'application/json', true, RequestMethod.Get, '/ventas/', true);
  private GET_RECARGAS: RequestConfig = new RequestConfig('SL007', 'application/json', true, RequestMethod.Get, '/ventas/recargas', true);
  private CREATE_SALE_NEW: RequestConfig = new RequestConfig('SL003', 'application/json', true, RequestMethod.Post, '/ventas/newCrearVenta', true);
  private VALIDATE_IMEI: RequestConfig = new RequestConfig('SLS009', 'application/json', true, RequestMethod.Get, '/ventas/{sucursal}/validaImei', true);
  private VALIDATE_BIN: RequestConfig = new RequestConfig('SL003', 'application/json', true, RequestMethod.Get, '/validarTarjeta', true);
  private VALIDATE_DOM: RequestConfig = new RequestConfig('SL003', 'application/json', true, RequestMethod.Post, '/337/domicilios/contratosVigentes', true);
  private VALIDATE_COBERTURA: RequestConfig = new RequestConfig('SL003', 'application/json', true, RequestMethod.Get, '/servicioCobertura', true);
  private VALIDATE_PHONE: RequestConfig = new RequestConfig('SL003', 'application/json', true, RequestMethod.Get, '/validacionCelular', true);
  private GET_GESTION_VENTA: RequestConfig = new RequestConfig('SL003', 'application/json', true, RequestMethod.Get, '/folioElectronicoProxis', true);
  private UPDATE_GESTION_VENTA: RequestConfig = new RequestConfig('SL003', 'application/json', true, RequestMethod.Put, '/folioElectronicoProxis', true);
  private CRETE_CLIENTE: RequestConfig = new RequestConfig('SL003', 'application/json', true, RequestMethod.Post, '/suscriptor/', true);
  private EDIT_SALE: RequestConfig = new RequestConfig('SL003', 'application/json', true, RequestMethod.Put, '/ventas/{idVenta}', true);
  private UPDATE_GEPOSITION_GROUP_OF_SALES: RequestConfig = new RequestConfig('SL003', 'application/json', true, RequestMethod.Put, '/geoposicionVentas', true);



  private infoUserLogger = null;
  constructor(private http: CustomHttp) { 
    this.infoUserLogger = JSON.parse(localStorage.getItem('info_user_logged'));
  }

  streetFromMega(streetName: string, sucursal: number, id_colonia?: string): Observable<StreetResponse> {
    const streetRequest: StreetRequest = {
      parcial: streetName,
      sucursal: sucursal,
      pageNumber: 1,
      pageSize: 1000,
      id_colonia: id_colonia || undefined 
    };
    // Elimina propiedades vacías
    for (const key in streetRequest) {
      if (streetRequest[key] === undefined || streetRequest[key] === null) {
        delete streetRequest[key];
      }
    }
    return this.http.sendRequestApiMega(this.STREET_REQUEST, streetRequest)
      .map((response) => (response.json() as StreetResponse[]).shift())
      .catch(error => this.http.handleError(error));
  }

Get_domicilios(datos: any): Observable<Any> {
  let provicional = {
    ... this.GET_DOMICILIOS
  }
  let url:string = provicional.uri;
  url = url + "?userName=" + datos.userName + "&idUserApp=" + datos.idUserApp;
  provicional.uri = url;
  return this.http.sendRequestToUrl(environment.MEGA_API_URL_VENTAS,provicional, datos)
      .map(res => res.json())
      .catch(error => this.http.handleError(error));
}


crear_ticket(ticket:Ticket){
  return this.http.sendRequestToUrl(environment.api_url,this.POST_TICKET, ticket)
      .map(res => res.json())
      .catch(error => this.http.handleError(error));
}

obtener_portabilidad(id_grupo?:any){
  let body = {
    //id_grupo: "13A573E0-3A85-4BC7-B08C-152E6FED6B12"
    id_grupo: id_grupo
  }
  return this.http.sendRequestToUrl(environment.MEGA_API_URL_VENTAS,this.POST_PORTABILIDAD, body)
      .map(res => res.json())
      .catch(error => this.http.handleError(error));
}

getRecargas(){
  
  this.GET_RECARGAS.uri = `/ventas/recargas`;
  return this.http.sendRequestToUrl(environment.API_MEGA_2,this.GET_RECARGAS)
      .map(res => res.json() || [])
      .catch(error => this.http.handleError(error));
}

validarImei(sucursal:any, imei:any){
  let datos={
    imei:imei
  }
  this.VALIDATE_IMEI.uri = `/ventas/${+sucursal}/validaImei`;
  return this.http.sendRequestToUrl(environment.API_MEGA_2,this.VALIDATE_IMEI,datos)
      .map(res => res.json() || [])
      .catch(error => this.http.handleError(error));
}

get_paquetes(sucursal:any,idUserApp: any){
  console.log(sucursal);
  let body = {
    sucursal: [Number(sucursal)],
    idUser:idUserApp
  }
  this.GET_PACKAGES.uri = `/ventas/paquetes`;
  return this.http.sendRequestToUrl(environment.API_MEGA_2,this.GET_PACKAGES,body)
      .map(res => res.json() || [])
      .catch(error => this.http.handleError(error));
}

sendRecovery(request: RecoveryRequest){
  return this.http.sendRequest(this.POST_TICKET, request)
      .map(res => res.json())
      .catch(error => this.http.handleError(error));
}

sendRecovery2(request: RecoveryRequest){
  return this.http.sendRequest(this.POST_RECOVERY, request);
}


// private getPackages(): Observable<SalePackage[]> {
//   return new Observable<SalePackage[]>((subscriber) => {

//           this.http.sendRequestToUrl(environment.api_url,
//               this.GET_PACKAGES, {sucursal: +this.infoUserLogger.userAppView.extra1})
//           .pipe(
//               map((res) => res.json() || []),
//           )
//           .subscribe((salePackages: SalePackage[]) => {
//               if (salePackages.length) {
//                   // this.saveOrUpdateSalePackages(salePackages)
//                   //     .then(() => {
//                           // this.salePackages = [];
//                           subscriber.next(salePackages);
//                       // });
//               } else {
//                   subscriber.next(salePackages);
//               }
//           }, (error) => subscriber.error(error));
//   });
// }

getSalesFolios(infoUserLogger:any,datos?:any): Observable<SaleFolio[]> {
  return new Observable<SaleFolio[]>((subscriber) => {
      let saleFolioRequest: SaleFolioRequest;;
      if(datos){
        saleFolioRequest = {
          sucursal: datos.sucursal,
          vendedor: datos.vendedor,
      };
      }else{
        saleFolioRequest = {
          sucursal: infoUserLogger.extra1,
          vendedor: infoUserLogger.extraConfiguration.nvm
      };
      }
    
      console.log(saleFolioRequest)
      this.http.sendRequestToUrl(environment.MEGA_API_URL_VENTAS, this.GET_SALES_FOLIOS,saleFolioRequest)
          .pipe(
              map((res) => res.json() || []),
          )
          .subscribe((saleFolios: SaleFolio[]) => {
              if (saleFolios.length) {
                  // this.saveOrUpdateSaleFolios(saleFolios)
                  //     .then(() => {
                  //         // this.saleFolios = [];
                  //         // subscriber.next(saleFolios);
                  //     });
                  subscriber.next(saleFolios);
              } else {
                  // this.loadSalesFoliosObservable();
                  subscriber.next(saleFolios);
                  // if (this.oauthService.appMode === AppMode.SALES) {
                  //     this.retrySalesFolios(true);
                  // }

              }
          }, (error) => {
              // this.loadSalesFoliosObservable();
              subscriber.error(error);
              
          });
  });
}

getSalesFoliosDigital(infoUserLogger:any,datos?:any): Observable<SaleFolio[]> {
  return new Observable<SaleFolio[]>((subscriber) => {
      let saleFolioRequest: any;
      if(datos){
        saleFolioRequest = {
          sucursal: datos.sucursal,
          vendedor: datos.vendedor,
          cantidad:datos.cantidad
      };
      }else{
        saleFolioRequest = {
          sucursal: infoUserLogger.extra1,
          vendedor: infoUserLogger.extraConfiguration.nvm
      };
      }
    
      console.log(saleFolioRequest)
      this.http.sendRequestToUrl(environment.MEGA_API_URL_VENTAS, this.GET_SALES_FOLIOS_DIGITAL,saleFolioRequest)
          .pipe(
              map((res) => res.json() || []),
          )
          .subscribe((saleFolios: SaleFolio[]) => {
              if (saleFolios.length) {
                  // this.saveOrUpdateSaleFolios(saleFolios)
                  //     .then(() => {
                  //         // this.saleFolios = [];
                  //         // subscriber.next(saleFolios);
                  //     });
                  subscriber.next(saleFolios);
              } else {
                  // this.loadSalesFoliosObservable();
                  subscriber.next(saleFolios);
                  // if (this.oauthService.appMode === AppMode.SALES) {
                  //     this.retrySalesFolios(true);
                  // }

              }
          }, (error) => {
              // this.loadSalesFoliosObservable();
              subscriber.error(error);
              
          });
  });
}

createSale(createRequest: CreateSaleRequest): Observable<any> {
  if (createRequest) {
      return  this.http.sendRequestToUrl(environment.MEGA_API_URL_VENTAS, this.CREATE_SALE,
          createRequest,
      )
          .pipe(
              map((response) => (response.json() as FolioResponse)),
              catchError((error) => {
                  try {
                      error = error.json();
                  } catch (e) {}
                  return throwError(error);
              })
          );
  } else {
      return throwError({message: 'Sin información para crear venta'});
  }
}
getPromocion(sucursal: any,promocion: number){
  let params = {
      promocion:promocion
  }
  this.GET_PROMOCION.uri = "/ventas/"+sucursal+"/promociones";
      return this.http.sendRequestToUrl(environment.Mega_url,this.GET_PROMOCION,params)
      .pipe(
          map((response) => {
              try {
                  return (response.json());
              } catch (e) {
                  return (this.http.handleError(e));
              }
          }),
          catchError(this.http.handleError)
      );
  
}


digitalFolio(digitalFolioRequest: DigitalFolioRequest): Observable<any> {
  if (digitalFolioRequest) {
      return this.http.sendRequestToUrl(environment.MEGA_API_URL_VENTAS, this.FOLIO,
        digitalFolioRequest)
          .pipe(
              catchError((error) => {
                  try {
                      error = error.json();
                  } catch (e) { }
                  return throwError(error);
              })
          );
  } else {
      return throwError({ message: 'Sin información para registrar folio electronico' });
  }
}

// customerDevicesAndServices(params: {sucursal: number, suscriptor: number}): Observable<DevicesAndServicesResponse> {
//   if (params) {
//       return this.customHttp.request(`${this.oauthService.envVariables.MEGA_API_URL}${this.CUSTOMER_SERVICES.uri}`, {
//           params,
//           method: this.CUSTOMER_SERVICES.method,
//           headers: new Headers({'Content-Type': this.CUSTOMER_SERVICES.contentType})
//       })
//           .pipe(
//               map((response) => {
//                   try {
//                       const serviceResponse: CustomerServiceResponse = (response.json() as CustomerServiceResponse);
//                       return {
//                           devices: serviceResponse.equipos
//                               .map((device) => (
//                                   [
//                                       {
//                                           key: 'modelo',
//                                           legend: 'Modelo',
//                                           value: device.modelo
//                                       },
//                                       {
//                                           key: 'estado',
//                                           legend: 'Estado',
//                                           value: device.estado
//                                       },
//                                   ]
//                               ) as KeyValueLegend[]),
//                           services: serviceResponse.servicios
//                               .map((service) => ({
//                                   tipo_servicio: service.tipo_servicio,
//                                   nombre: service.nombre_servicio,
//                                   descripcion: service.servicio,
//                                   estado: service.estado
//                               } as CustomerService))
//                       } as DevicesAndServicesResponse;
//                   } catch (e) {
//                       return ({
//                           devices: [],
//                           services: []
//                       } as DevicesAndServicesResponse);
//                   }
//               }),
//               catchError((error) => {
//                   throwError(error);
//                   return of<DevicesAndServicesResponse>({
//                       devices: [],
//                       services: []
//                   } as DevicesAndServicesResponse);
//               })
//           );
//   } else {
//       return of<DevicesAndServicesResponse>({
//           devices: [],
//           services: []
//       } as DevicesAndServicesResponse);
//   }
// }

//VentaE2E 1 peticion
createSaleone(createRequest: any): Observable<any> {
  if (createRequest) {
    return  this.http.sendRequestToUrl(environment.Mega_url, this.CREATE_SALE_NEW,
        createRequest,
    )
        .pipe(
            map((response) => (response.json() as FolioResponse)),
            catchError((error) => {
                try {
                    error = error.json();
                } catch (e) {}
                return throwError(error);
            })
        );
} else {
    return throwError({message: 'Sin información para crear venta'});
}
}
customerDevicesAndServices(suscriptor:number): Observable<DevicesAndServicesResponse> {
  return this.http.sendRequestToUrl(environment.MEGA_API_URL2,this.CUSTOMER_SERVICES,{sucursal: +this.infoUserLogger.userAppView.extra1, suscriptor: suscriptor })
  .map((response) => {
    try {
        const serviceResponse: CustomerServiceResponse = (response.json() as CustomerServiceResponse);
        return {
            devices: serviceResponse.equipos
                .map((device) => (
                    [
                        {
                            key: 'modelo',
                            legend: 'Modelo',
                            value: device.modelo
                        },
                        {
                            key: 'estado',
                            legend: 'Estado',
                            value: device.estado
                        },
                    ]
                ) as KeyValueLegend[]),
            services: serviceResponse.servicios
                .map((service) => ({
                    tipo_servicio: service.tipo_servicio,
                    nombre: service.nombre_servicio,
                    descripcion: service.servicio,
                    estado: service.estado
                } as CustomerService))
        } as DevicesAndServicesResponse;
    } catch (e) {
        return ({
            devices: [],
            services: []
        } as DevicesAndServicesResponse);
    }
})
      .catch(error => this.http.handleError(error));
}



validateBin(request:any): Observable<any> {
  console.log(request)
  if (request) {
    this.VALIDATE_BIN.uri = "/validarTarjeta?tarjeta="+(request.tarjeta).toString()+"&vendedor="+(request.vendedor).toString();
    return this.http.sendRequestToUrl(environment.API_MEGA_2,this.VALIDATE_BIN)
        .map(res => res.json() || [])
        .catch(error => this.http.handleError(error));

  } else {
      return throwError({message: 'Error en el endpoint de validar bin.'});
  }
}

validateAddresse2e(data: any, extra1): Observable<Response> {
  let body = {
      domicilio: data
  }
  this.VALIDATE_DOM.uri = "/" +extra1+"/domicilios/contratosVigentes";
      return this.http.sendRequestToUrl(environment.MEGA_API_URL_VENTAS,this.VALIDATE_DOM, body)
            .map((res) => res.json())
            .catch((error) => this.http.handleError(error));
}

validateCobertura(request:any): Observable<any> {
  if (request) {
          return this.http.sendRequestToUrl(environment.MEGA_API_URL_VENTAS,this.VALIDATE_COBERTURA, request)
                .map((res) => res.json() as FolioResponse)
                .catch((error) => this.http.handleError(error));
  } else {
      return throwError({message: 'Error en el endpoint de cobertura.'});
  }
}

validateTelefono(request:any): Observable<any> {
  if (request) {
          return this.http.sendRequestToUrl(environment.MEGA_API_URL_VENTAS,this.VALIDATE_PHONE, request)
                .map((res) => res.json() as FolioResponse)
                .catch((error) => this.http.handleError(error));
  } else {
      return throwError({message: 'Error en el endpoint de validar numero.'});
  }
}

getFolioGestionVenta(request:any): Observable<any> {
  if (request) {
    this.VALIDATE_DOM.uri = "/" +request+"";
          return this.http.sendRequestToUrl(environment.MEGA_API_URL_VENTAS,this.GET_GESTION_VENTA, request)
                .map((res) => res.json() as FolioResponse)
                .catch((error) => this.http.handleError(error));
  } else {
      return throwError({message: 'Error en el endpoint de validar numero.'});
  }
}

updateFolio(params: any, id_folio: any): Observable<any>{
  console.log(params)
  if(params){
    this.UPDATE_GESTION_VENTA.uri= "/folioElectronicoProxis?id_folio="+id_folio
    return this.http.sendRequestToUrl(environment.Mega_url, this.UPDATE_GESTION_VENTA, params)
        .map(res => res.json())
        .catch(error => this.http.handleError(error));
  }else{
    return throwError({message: 'Sin información para actualizar'});
  }
  
}

createClient(datos:any,sucursal:number){
  if (sucursal) {
    this.CRETE_CLIENTE.uri="/suscriptor/"+sucursal
    return  this.http.sendRequestToUrl(environment.Mega_url, this.CRETE_CLIENTE,
        datos,
    )
        .pipe(
            map((response) => (response.json() as FolioResponse)),
            catchError((error) => {
                try {
                    error = error.json();
                } catch (e) {}
                return throwError(error);
            })
        );
  } else {
      return throwError({message: 'Sin información para crear cliente'});
  }
}


updateVenta(data: any, id_venta: any): Observable<any>{
  console.log(data)
  if(data){
    this.EDIT_SALE.uri= "/ventas/"+id_venta
    return this.http.sendRequestToUrl(environment.Mega_url, this.EDIT_SALE, data)
        . map((response) => {
          return 'ok'
  })
        .catch(error => this.http.handleError(error));
  }else{
    return throwError({message: 'Sin información para actualizar la venta'});
  }
  
}


  updateGeopositionGroupOfSales(request: UpdateGeopositionGroupOfSales): Observable<any> {
    if (request) {
      return this.http.sendRequestToUrl(environment.Mega_url, this.UPDATE_GEPOSITION_GROUP_OF_SALES, request)
        .map(res => res)
        .catch(error => this.http.handleError(error));
    }
    else {
      return throwError({ message: 'Sin información para actualizar' });
    }
  }

  suburbFromMega(suburbName: string, sucursal: number, cp?: number): Observable<any> {
    const suburbRequest: SuburbRequest = {
      parcial: suburbName,
      sucursal: sucursal,
      codigo_postal: cp,
      pageNumber: 1,
      pageSize: 50
    };
    // Elimina propiedades vacías
    for (const key in suburbRequest) {
      if (suburbRequest[key] === undefined || suburbRequest[key] === null) {
        delete suburbRequest[key];
      }
    }
    // Usamos GET_COLONIAS_DOM
    return this.http.sendRequestApiMega(this.GET_COLONIAS_DOM, suburbRequest)
      .map((response) => (response.json() as SuburbResponse[]).shift())
      .catch(error => this.http.handleError(error));
  }


}

export class UpdateGeopositionGroupOfSales {
  latitud: number;
  longitud: number;
  domicilio_validado: boolean;
  id_grupo: string;
  precision_geo: number;
}
export class StreetRequest {
  sucursal: number;
  parcial?: string;
  pageNumber: number;
  pageSize: number;
  idStreet?: string;
  idCalle?: string;
  id_colonia?: string;
}

export class GetStreetColony{
  idCalle?: string;
  idColonia?: string;
}

export class StreetResponse {
  totalResults: number;
  pagesCount: number;
  pageNumber: number;
  pageSize: number;
  calles: StreetFromMega[];
}

export class GetStreetColonyResponse {
 id?: [];
 colonia?:[];
 calle?:[];
}

export class StreetFromMega {
  id: string;
  nombre: string;
}

export interface SalesFoundCustomer {
    sucursal?: number;
    suscriptor: number;
    nombre?: string;
    ap_pat?: string;
    ap_mat?: string;
    calle: string;
    numero?: number;
    interior?: number;
    departamento?: number;
    bis?: string;
    cp?: string;
    colonia?: string;
    ecalle1?: string;
    ecalle2?: string;
    n_com?: string;
    lat?: number;
    lng?: number;
    tel_casa?: string;
    tel_cel?: string;
    tel_ofi?: string;
    email?: string;
    saldo?: number;
    estado?: string;
    municipio?: string;
    nombre_comercial?: string;
    promocion?:string;
    folio_trabajo?:string;
    tipo_trabajo?:string;
}

export class Ticket {
  idTicket: number;
  idTicketParent: number;
  summary: string;
  description: string;
  folio: string;
  idUserApp: number;
  assignee: string;
  idGroup: number;
  group: string;
  idPriority: number;
  priority: string;
  channel: any;
  createdDate: Date;
  plannedStartDate: Date;
  plannedEndDate: Date;
  startDate: Date;
  solveDate: Date;
  cancelledDate: Date;
  closeDate: Date;
  cancelledReason: string;
  closingComments: string;
  idCloseCategory: number;
  closeCategoryName: string;
  idCloseSubcategory: number;
  closeSubcategoryName: string;
  idOrg: string;
  workingTime: number;
  remainingTime: number;
  requesterUsername: string;
  requesterName: string;
  requesterUserName?: string;
  idStatus: number;
  ticketStatusValue: string;
  idSubcategory: number;
  subcategoryName: string;
  externalId: number;
  extra1: string;
  extra2: string;
  extra3: string;
  customerData: CustomerTicket;
  ticketCategory:any;
  ticketType: any
  eventos: any;
  extraInfoList: Array<KeyValueLegend> = [];;
  format: any;
  labels: any;
  tasks: any;
  numberVisits: number = 0;
  resolutionTime: number = 0; 
}



export class FieldDefinition {
  idTicketField: number;
  key: string;
  legend: string;
  active: boolean;
  fieldType: string;
  fieldValidation: string;
  createdDate: Date;
  validationMessage: string;
}


export class CustomerInfo {
  idTicketCustomer: number;
  key: string;
  value: any;
  legend: string;
}

export class KeyValueLegend {
  key: string;
  value: any;
  legend: string;
}


export class Customer {
  name: string;
  paternalName: string;
  maternalName: string;
  commercialName: string;
  createdDate: Date;
  customerStatus: string;
  rfc: string;
  customerType: string;
  idCustomer: number;
  address: Array<Address> = [];
  phone: string;
  phoneNumbers: Array<ContactNumbers> = [];
  giro: string
}


export class Address {
  idCustomerAddress: number;
  street: string = '';
  numExt: string = '';
  numInt: string = '';
  zipCode: number;
  country: string = '';
  state: string = '';
  city: string = '';
  suburb: string = '';
  street1: string = '';
  street2: string = '';
  addressStatus: string = '';
  latitude: number;
  longitude: number;
  department: string = '';
  bis: string = '';
}

export class ContactNumbers {
  idCustomerContactNumber: number;
  phone: string;
  phoneType: string;
  createdDate: Date;
  modifiedDate: Date;
  contactNumberStatus: string;
}

export interface CustomerService {
  tipo_servicio: number;
  nombre: string;
  descripcion: string;
  estado: string;
}


export class TicketType {
  idTicketType: number;
  ticketType: string;
  prefix: string;
  proccesInstanceName: string;
  taskInstanceName: string;
  idOrg: string;
}

export class TicketCategory {
  ticketCategoryId: number;
  categoryName: string;
  active: boolean;
  code: number;
  color: string;
  idTypeTicket: number;
  nameTypeTicket: string;
  idOrg: string;
}

export class TicketSubCategory {
  active: boolean;
  code: number;
  color: string;
  idCategory: number;
  idSubcategory: number;
  subcategoryName: string;
}

export class TicketPriority {
  idPriority: number;
  description: string;
  number: number;
  color: string;
  enable: boolean;
  rowVersion: number;
}

export class TicketStatus {
  idStatus: number;
  description: string;
  color: string;
  enable: boolean;
}


export interface SalePackage {
  idPackage: number;
  idPackageMega: string;
  branch: number;
  namePackage: string;
  details: string;
  summary: string;
  price: number;
  typePackage?: number;
  rowVersion: number;
  active:string;
  newDetailPackage?: NewDetailPackage;
  nivel: number;
}

export class NewDetailPackage {
  tipoServicio?: TypeService;
  tipoPago?: TypePayment;
  television?: string;
  internet?: string;
  telefoniaFija?: string;
  servicio?: string;
  descripcion?: string;
}

export enum TypeService {
  paqueteFijo = 1,
  servicioAdicional = 2,
}

export enum TypePayment {
  pospago = "posPago",
  prepago = "prePago",
}


export enum TipoContrato{
  MEGACABLE = 1,
  MEGAMOVIL = 2,
  MEGACABLEYMEGAMOVIL = 3
}


export interface SaleSummary {
    id: number;
    idUser: number; // idUserApp
    idPackage: number;
    money: number;
    productivity: number;
    idTicket: number;
    registrationTimestamp: number;
}

export interface SaleFolio {
    folio: number;
    fecha: string;
}

export interface SaleFolioRequest {
    sucursal: string;
    vendedor: number;
}

export class empresa {
  nombre_comercial: string;
  giro?: string;
  representante_legal?: string;
}

export class datos {
  apellido_paterno: string;
  apellido_materno: string;
  nombre: string;
  empresa: empresa;
}

export class datosAdicionales {
  email: string;
  telefono_celular: string;
}

export class entre {
  id_calle1: string;
  id_calle2: string;
}

export class calles {
  id_calle: string;
  entre: entre;
}

export class telefonos {
  telefono_casa: string;
  telefono_oficina: string;
}

export class geograficos {
  latitud: number;
  longitud: number;
}

export class fechas {
  orden_fechadesde: string;
  orden_fechahasta: string;
}

export class observaciones {
  orden_perro: boolean;
  orden_timbre: boolean;
  orden_confirmar: boolean;
  orden_hora: string;
  no_generar_edocta: boolean;
  observaciones: string;
  geograficos: geograficos;
  fechas: fechas;
}

export class domicilio {
  id: string;
  id_ciudad: string;
  id_colonia: string;
  calles: calles;
  numero_exterior: number;
  numero_interior: number;
  orientacion: string;
  departamento: number;
  bis: string;
  codigo_postal: string;
  manzana: string;
  lote: number;
  telefonos: telefonos;
  observaciones: observaciones;
  datosTecnicos: datosTecnicos;
}
export class ctc {
  puerto_optico:string;
        nodo_cmts:string;
        puerto:string;
        ctc_hub:string;
}
export class gpon {
  gpon_etiqueta: string;
        gpon_fsp: string;
        gpon_ip_olt: string;
}
export class datosTecnicos {
  zona: number;
  sector_plano: number;
  nodo: number;
  troncal: number;
  line_extender: number;
  tap: number;
  poste: number;
  ruta: string;
  troncal_distribucion: string;
  ctc:ctc;
  gpon:gpon
}

export class agregarUsuarioYDomicilio  {
    datos: datos;
    datosAdicionales: datosAdicionales;
    domicilio: domicilio;
}


export interface BitacoraResponse {
    idTransaction: string;
}

export class CamposContratos {

  //MEGAMOVIL

  telefonia_movil?: string; //N o S
  plan_telefonia?: string;
  sms_incluidos?: string;
  mb_telefonia_movil?: string;
  cargo_mensual_telefonia?: string;

  internet_fijo?: string;
  plan_internet_fijo?: string;
  velocidad_internet_fijo?: string;
  mb_internet_fijo?: string;
  cargo_mensual_internet_fijo?: string;

  internet_movil?: string;
  plan_internet_movil?: string;
  mb_internet_movil?: string;
  cargo_mensual_internet_movil?: string;

  costo_inicial?: number;
  costo_inicialFormated?: any;
  cargo_total_servicios?: number;
  cargo_total_serviciosFormated?: any;

  tipoEquipo?: number;
  marca_equipo_propio?: string;
  imei_equipo_propio?: string;

  modelo_equipo_provisto?: string;
  sim_equipo_provisto?: string;
  imei_equipo_provisto?: string;
  pago_inicial_equipo_provisto?: number;
  pago_inicial_equipo_provistoFormated?: any;
  cargo_mensual_equipo_provisto?: number;
  cargo_mensual_equipo_provistoFormated?: any;

  tipoPago: any;

  pago_en_efectivo: string;
  cargo_automatico_tarjeta: string;

  numero_tarjeta?: any;
  numero_tarjetaFormated?: any;
  institucion_bancaria?: string;
  vigencia_tarjeta?: any;
  vigencia_tarjeta_formated?: string = '';
  cargo_meses_tarjeta?: any;


  tipoPlazo: any;

  plazo_forzado?: string;
  meses_plazo?: number;

  plazo_indefinido?: string;
  nombre_plazo?: string;
  detalle_plazo?: string;
  costo_plazo?: any;
  costo_plazoFormated?: any;

  autoriza_info_transmitida?: any;
  autoriza_datos_publicitarios?: any;
  autoriza_info_investigacion?: any;
  autoriza_carta_derechos?: any;
  autoriza_estado_cuenta_email?: any;
  autoriza_estado_cuenta_sms?: any;
  autoriza_info_contrato?: any;

  //  email
  celular_contacto?: number;

  //MEGACABLE

  contratacion_tv?: any;
  contratacion_internet?: any;
  contratacion_telefonia?: any;

  tarifa_contratacion?:any;
  tarifa_contratacionFormated?: any;

  mensualidad_tv?:any;
  mensualidad_tvFormated?:any;

  mensualidad_telefonia?:any;
  mensualidad_telefoniaFormated?:any

  mensualidad_internet?:any;
  mensualidad_internetFormated?:any

  contratacion_hd?: any;
  descripcion_hd?: string;
  contratacion_premier?: any;
  descripcion_premier?: string;

  recepcion_equipo?:any;

  autoriza_aviso_privacidad?: any;
  autoriza_carta_derechos_email?: any;


}

export interface Paquetes {
  id_paquete: string;
  detalle_paquete: string;
  nivel: number;
  solicitud_venta: number;
  importe: any;
  promocion: number;
  nombrePaquete: string;
  newDetailPackage?: any;
  idPackage: number;
  concepto_recarga?:any;
}


export interface SalesCustomer {
  address: string;
  number: number;
  subscriber: string;
}

export interface SalesFindRequest {
  sucursal: number;
  suscriptor?: number;
  nombre?: string;
  apellido_paterno?: string;
  apellido_materno?: string;
  calle?: string;
  numero?: number;
  interior?: number;
  departamento?: number;
  bis?: string;
  telefono?: string;
}

export interface SalesFindResponse {
  personas: SalesFoundCustomer[];
}

export interface SalesFoundCustomer {
  sucursal?: number;
  suscriptor: number;
  nombre?: string;
  ap_pat?: string;
  ap_mat?: string;
  calle: string;
  numero?: number;
  interior?: number;
  departamento?: number;
  bis?: string;
  cp?: string;
  colonia?: string;
  ecalle1?: string;
  ecalle2?: string;
  n_com?: string;
  lat?: number;
  lng?: number;
  tel_casa?: string;
  tel_cel?: string;
  tel_ofi?: string;
  email?: string;
  saldo?: number;
  estado?: string;
  municipio?: string;
  nombre_comercial?: string;
  id_calle?: string;
  id_calle1?: string;
  id_calle2?: string;
  id_colonia?: string;
  promocion?:string;
  folio_trabajo?:string;
  tipo_trabajo?:string;
  
}

export interface DevicesAndServicesResponse {
  devices: KeyValueLegend[][];
  services: CustomerService[];
}
export interface CustomerServiceResponse {
  equipos: ObjectDeviceResponse[];
  estado: string;
  servicios: ObjectServiceResponse[];
  sucursal: number;
  suscriptor: number;
}

export interface ObjectDeviceResponse {
  modelo: string;
  estado: string;
}

export interface ObjectServiceResponse {
  tipo_servicio: number;
  nombre_servicio: string;
  servicio: string;
  estado: string;
  fecha_contratacion: Date;
  fecha_corte: Date;
  fecha_ultimo_pago: Date;
  cantidad: number;
  equipo: string;
  tipo_contrato: string;
  cantidad_real: number;
}

export interface CreateSaleRequest {
  sucursal: number;
  fecha_Registro: number;
  suscriptor: number;
  nombre: string;
  apellido_paterno: string;
  apellido_materno: string;
  estado: string;
  numero_exterior: number;
  numero_interior: number;
  orientacion: string;
  departamento: number;
  bis: string;
  id_colonia: string;
  id_calle: string;
  id_calle1: string;
  id_calle2: string;
  telefono_contacto: string;
  // id_paquete: string;
  estado_venta: string;
  // solicitud_venta: number;
  // importe: number;
  // promocion: number;
  latitud: number;
  longitud: number;
  origen: string;
  paquetes: Paquetes[],
  motivo_rechazo: string;
  condiciones_comerciales: string;
  observaciones: string;
  customer_data?: agregarUsuarioYDomicilio ;
  numero_tarjeta: string;
  vigencia_tarjeta: string;
  aprobacion_tarjeta: number;
  whatsapp?:any;
  ventaOffline?:any;
}

export interface Paquetes {
id_paquete: string;
detalle_paquete: string;
nivel: number;
solicitud_venta: number;
importe: any;
promocion: number;
nombrePaquete: string;
newDetailPackage?: any;
idPackage: number;
}

export interface FolioResponse {
  id_grupo: string;
  id: number[];
}

export interface DigitalFolioRequest {
  estatus: string;
  fecha_creacion: any;
  id_docto: number;
  id_folio: string; // "a729fe40-17c4-11eb-9aa0-574e8cdc5a66", //uuid de 36
  json_generado: Folio;
  nombre_suscriptor: string;
  nombre_vendedor: string;
  sucursal: number;
  suscriptor: string;
  username: string;
  id_folio_externo?: number;
  base64Firma?: string;
  numero_vendedor?: any;

}

export interface Folio {
  type: string;
  value: string;
}

export interface FolioValue {
  id_folio: string;
  fecha: any;
  suscriptor: string,
  nombre_cliente: string;
  representante_legal: string;
  giro: string;
  bis?:string;
  nombre_comercial: string;
  rfc:string;
  calle: string;
  num_ext: string;
  num_int: string;
  entre_calle_1: string;
  entre_calle_2: string;
  colonia: string;
  localidad: string;
  municipio: string;
  estado: string;
  cp: string;
  telefono_contacto: string;
  enviar_email: string;
  instalacion_dias_hab: string;
  clave_del_promotor: string;
  vendedor_asociado: string;
  post_pago: string;
  cuenta_con_hmdi: string;
  pre_pago: string;
  post_pago_video: string;
  post_pago_datos: string;
  post_pago_voz: string;
  pre_pago_video: string;
  pre_pago_datos: string;
  pre_pago_voz: string;
  pre_pago_video_desc: string;
  pre_pago_voz_desc: string;
  pre_pago_datos_desc: string;
  post_pago_video_desc: string;
  post_pago_voz_desc: string;
  post_pago_datos_desc: string;
  post_pago_tarifas_aplicables: string;
  pre_pago_tarifas_aplicables: string;
  post_pago_tarifas_aplicables_adic: string;
  post_pago_servicio_uno: string;
  post_pago_servicio_dos: string;
  post_pago_servicio_tres: string;
  post_pago_servicio_uno_desc: string;
  post_pago_servicio_dos_desc: string;
  post_pago_servicio_tres_desc: string;
  promocion_numero: string;
  promocion_desc: string;
  observaciones: string;
  total_recibido: string;
  pago_en_efectivo: string;
  cargo_automatico: string;
  cargo_automatico_tarjeta: string;
  cargo_automatico_banco: string;
  cargo_automatico_vigencia: string;
  telefono: string;
  email: string;
  contrato_vigencia_plazo_indefinido: string;
  contrato_vigencia_plazo_forzoso: string;
  contrato_vigencia_plazo_forzoso_meses: string;
  acepta_autoriza_transmitida: string;
  acepta_autoriza_publicidad: string;
  acepta_autoriza_investigar: string;
  acepta_autoriza_informado: string;
  acepta_autoriza_edocta_sms: string;
  acepta_autoriza_edocta_correo: string;
  acepta_autoriza_carta_derechos: string;
  id_folio_externo?: number;
  nombrePaquete?: string;
  detalle_paquete?: string;

  //MEGAMOVIL
  telefonia_movil?: string;
  plan_telefonia?: string;
  sms_incluidos?: string;
  mb_telefonia_movil?: string;
  cargo_mensual_telefonia?: string;

  internet_fijo?: string;
  plan_internet_fijo?: string;
  velocidad_internet_fijo?: string;
  mb_internet_fijo?: string;
  cargo_mensual_internet_fijo?: string;

  internet_movil?: string;
  plan_internet_movil?: string;
  mb_internet_movil?: string;
  cargo_mensual_internet_movil?: string;

  costo_inicial?: number;
  cargo_total_servicios?: number;

  marca_equipo_propio?: string;
  imei_equipo_propio?: string;

  modelo_equipo_provisto?: string;
  sim_equipo_provisto?: string;
  imei_equipo_provisto?: string;
  pago_inicial_equipo_provisto?: number;
  cargo_mensual_equipo_provisto?: number;

  //pago_en_efectivo
  //cargo_automatico_tarjeta
  numero_tarjeta?: number;
  institucion_bancaria?: string;
  vigencia_tarjeta?: string;
  cargo_meses_tarjeta?: number;


  plazo_forzado?: string;
  meses_plazo?: number;

  plazo_indefinido?: string;
  nombre_plazo?: string;
  detalle_plazo?: string;
  costo_plazo?: number;

  autoriza_info_transmitida?: string;
  autoriza_datos_publicitarios?: string;
  autoriza_info_investigacion?: string;
  autoriza_carta_derechos?: string;
  autoriza_estado_cuenta_email?: string;
  autoriza_estado_cuenta_sms?: string;
  autoriza_info_contrato?: string;

  // email
  celular_contacto?: number;

  //MEGACABLE

  contratacion_tv?: any;
  contratacion_internet?: any;
  contratacion_telefonia?: any;

  tarifa_contratacion?:any;

  mensualidad_tv?:any;

  mensualidad_telefonia?:any;

  mensualidad_internet?:any;

  contratacion_hd?: any;
  descripcion_hd?: string;
  contratacion_premier?: any;
  descripcion_premier?: string;

  recepcion_equipo?:any;

  autoriza_aviso_privacidad?: string;
  autoriza_carta_derechos_email?: string;

  banderaContrato: boolean;

  newDetailPackage: any,
  numero_vendedor: any,
  efectivo: boolean;
}



export interface StreetRequest {
  sucursal: number;
  parcial?: string;
  pageNumber: number;
  pageSize: number;
}

export interface StreetResponse {
  totalResults: number;
  pagesCount: number;
  pageNumber: number;
  pageSize: number;
  calles: StreetFromMega[];
}

export interface StreetFromMega {
  id: string;
  nombre: string;
}

export interface SuburbRequest {
  sucursal: number;
  parcial?: string;
  codigo_postal?: number;
  pageNumber: number;
  pageSize: number;
}

export interface SuburbResponse {
  totalResults: number;
  pagesCount: number;
  pageNumber: number;
  pageSize: number;
  colonias: SuburbFromMega[];
}

export interface SuburbFromMega {
  id: string;
  nombre: string;
  sector: string;
  nse: string;
  fechaActivacion: Date;
  tipoComunicacion: string;
  codificada: {
      valor: boolean,
      fechaInicio: Date
  };
  subterranea: boolean;
  digital: boolean;
  competencia: boolean;
  docsis30: boolean;
  hfc: boolean;
  gpon: boolean;
  restringidos: string;
  metroCarrier: boolean;
}

export interface SalePackage {
  idPackage: number;
  idPackageMega: string;
  branch: number;
  namePackage: string;
  details: string;
  summary: string;
  price: number;
  typePackage?: number;
  rowVersion: number;
  active:string;
  newDetailPackage?: NewDetailPackage;
  nivel: number;
}

export interface detalle_paquete{
tipoServicio: 1,// 1 paquete fijo, 2 servicios adicionales
tipoPago: string, // Postpago o Prepago
television: string,
internet: string,
telefoniaFija: string,
servicio: string,
descripcion: string
}


export interface SaleSummary {
  id: number;
  idUser: number; // idUserApp
  idPackage: number;
  money: number;
  productivity: number;
  idTicket: number;
  registrationTimestamp: number;
}

export interface SaleFolio {
  folio: number;
  fecha: string;
}

export interface SaleFolioRequest {
  sucursal: string;
  vendedor: number;
}


export interface BitacoraResponse {
  idTransaction: string;
}

export class CustomerTicket {
  idCustomerData: number;
  idExternalCustomer: number;
  nameComplete: string;
  commercialName: string;
  customerInfo: CustomerInfo[] = [];

  /**
   * Return the result as CustomerInfo object or _undefined_ if not found.
   * @param key CustomerInfo -> key to looking for
   */
  getCustomerInfo(key: string): CustomerInfo {
      return this.customerInfo.find((info) => info.key.toLowerCase() === key.toLowerCase());
  }

  /**
   * Returns the index in the array for the found object or _-1_ if not found.
   * @param key CustomerInfo -> key to looking for
   */
  getCustomerInfoIndex(key: string): number {
      return this.customerInfo.findIndex((info) => info.key.toLowerCase() === key.toLowerCase());
  }
}

export class LocationDevice {
  public lat: number = 0;
  public lng: number = 0;
  public speed: number = 0;
  public timestamp: number = 0;
  public locationId: number;

  constructor(lat: number, lng: number, speed: number, timestamp: number, locationId: number) {
      this.lat = lat;
      this.lng = lng;
      this.speed = speed;
      this.timestamp = timestamp;
  }
}

export class LocationRequest {
  latitude: number;
  longitude: number;
  speed: number;
  applicationName: string;
  referenceId: number;
  idUser: number;
  username: string;
  createdDate: number;
  customerId: number;
  typePoint: TypePoint;
  idTicket?: number;
}

export enum TypePoint {
  POINT = 1,
  SALE = 2,
  PANIC = 3,
  MAXTIME = 4,
  SPEEDING = 5
}

export enum RecoveryType {
  DEVICE = 1,
  MONEY = 2,
  BOTH = 3,
  SALE = 4
}

export class ExtraInfoList extends KeyValueLegend {
  idTicketExtraInfo?: number;
  fieldDefinition?: FieldDefinition = new FieldDefinition();
}

export interface CustomerService {
  tipo_servicio: number;
  nombre: string;
  descripcion: string;
  estado: string;
}

export class Comments {
  idComment: number;
  commentDate: number | Date;
  comment: string;
  activityType: string;
  commentVisibility: string;
  commentName: string;
  commentUsername: string;
  attachments: Array<Attachments> = [];
  deviceId: string;
  idTicket: number;
  idTask: number;
  solicitudVenta?: any;
  user?: boolean;
  engineering_registration?: EngineeringRegistration;
}

export class Attachments {
  idAttachment: number;
  contentType: string;
  fileB64Content: string;
  fileName: string;
  size: number;
  uploadDate: Date;
  fileSystemPath: string;
  idComment: number;
  code?: number;
}

export class RecoveryRequest {
  idTicket: number;
  idTask?: number;
  idUserApp: number;
  fechaRegistro: number;
  comentarios: string;
  idPromocion?: string;
  totalRecuperado?: number;
  equipos?: RecoveryRequestDevice[];
  motivoRechazo?: string;
  groupId?: number;
  groupName?: string;
  causaVisita?: string;
  suscriptor?: number;
  tipoBitacora?: RecoveryLogType;
  latitud?: any;
  longitud?: any;
  tipoRecuperacion?: RecoveryType;
  idVendedor?: number;
  idPaquete?: string;
  productividad?: number;
  motivoVenta?: string;
  folio?: number;
  nivelSocioeconomico?:string;
  tipoCliente?:string;
  id_folio?: string;
  recuperacionVentas?: boolean;
}

export interface RecoveryRequestDevice {
  idTicket?: number;
  tipoEquipo: number;
  modelo: string;
  serie: string;
  fuente: boolean;
  controlRemoto: boolean;
}

export class RequestEditarFolio {
  suscriptor: any;
  datos: Dato[];
  idTicket: number;
  cliente_nuevo: number;
}

export class Dato {
  idVenta: string;
  idGrupo: string;
  solicitud_venta: number;
}


export enum RecoveryLogType {
  CNR = 1,
  VISIT = 2,
  RECOVER = 3,
  VISITSALE = 4,
  SALE = 5
}
